import { fetchWrapper } from "../utils/fetch"
import { globalState } from "./global-state";
import { gotoPageCertificado } from "./pages/certificado/certificado";
import { gotoPassoContratacao } from "./pages/seguro/passo-contracao";
import { gotoPassoSeguro } from "./pages/seguro/passo-seguro";
import { ISummaryBoxState } from "./summaryBox";

export enum enumPasso {
    seguro = 1,
    contratacao = 2,
    certificado = 3
}

export interface ISimulacaoState {
    idSimulacao: number
    passo: enumPasso
    passoAlcancado: enumPasso
    ehSeguradoComDoisSegurosAtivos: boolean
    summaryBox: ISummaryBoxState
}

export const getSimulacao = () =>
    fetchWrapper<ISimulacaoState>("/api/simulacao")

export const init = async () => {
    const simulacao = await getSimulacao();
    
    if (!simulacao)
        return

    globalState.simulacao.set(simulacao);

    switch(simulacao.passo) {
        case enumPasso.seguro:
            await gotoPassoSeguro();
            break;
        case enumPasso.contratacao:
            await gotoPassoContratacao();
            break;
        case enumPasso.certificado:
            await gotoPageCertificado();
            break;
    }
    
}

